import React, { useState } from "react";
import CardContenido from "./CardContenido";
import arrow_up from "../../../../assets/vw/svg/arrow-up.svg";
import arrow_down from "../../../../assets/vw/svg/arrow-down.svg";

const SelectCard = ({
    infoCard,
    index,
    selectCheck,
    checked,
    currentActive,
    setCurrentActive,
    handleReenviar = () => { },
}) => {

    const [showContent, setShowContent] = useState(false);

    return (
        <div className="select-card-container">
            <div className="select-card-header d-flex justify-content-between">
                <div className="d-flex">
                    <div className="ms-auto align-self-center">
                        <input
                            type="checkbox"
                            className="checkbox-round"
                            checked={checked}
                            onChange={(e) => selectCheck(e.target.checked, index)}
                        />
                    </div>
                    <div className="container_id_reenviar bold ml-3 mr-1 font-weight-bolder d-flex flex-column flex-md-row">
                        <div>{infoCard.original.idCuentaContacto}</div>
                        <div>{infoCard.original.marca}</div>
                    </div>

                </div>
                <button
                    className="button_icon-vw select-card-arrow"
                    onClick={() => {
                        setShowContent(prev => !prev);
                        setCurrentActive({ id: index });
                    }}
                >
                    {(showContent && currentActive.id === index) ? (
                        <img src={arrow_up} alt="arrow-up" className="px-1" />
                    ) : (
                        <img src={arrow_down} alt="arrow-down" className="px-1" />
                    )}
                </button>
            </div>

            {(showContent && currentActive.id === index) && (
                <CardContenido
                    infoCard={infoCard}
                    id={index}
                    setShowContent={setShowContent}
                    handleReenviar={handleReenviar}
                />
            )}
        </div>
    );
};

export default SelectCard;
